export const enum GameMenuState {
    None = 'None',
    Start = 'Start',
    Exit = 'Exit',
    Scoreboard = 'Scoreboard',
    Over = 'Over',
}
